// ═══════════════════════════════════════════════════════════════════════════════
// Client-side image preprocessing for task photo uploads (same pipeline as receipt AI).
// ═══════════════════════════════════════════════════════════════════════════════

import { compressImageFile, resolveClientImageMime } from './receiptImagePreprocess';

/**
 * Resize + WebP/JPEG encode using the same Safari-safe path as receipt analyze.
 * On failure, returns the original file so the caller can still attempt upload.
 */
export const compressImageForUpload = async (file: File): Promise<File> => {
  if (resolveClientImageMime(file) === null) {
    return file;
  }
  try {
    const { blob, fileName, mime } = await compressImageFile(file);
    return new File([blob], fileName, { type: mime });
  } catch {
    return file;
  }
};
